module.exports = __webpack_public_path__ + "media/images/ic-caixa-confete-c685ea1b691ee1174620d0cbe3db0fee.svg";